import { render } from "./PodcastsView.vue?vue&type=template&id=96a5248e"
import script from "./PodcastsView.vue?vue&type=script&lang=js"
export * from "./PodcastsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__